import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import UnapprovedProduce from "./UnapprovedProduce";
import ApprovedProduce from "./ApprovedProduce";

const AmtplCommunication = () => {
    const [activeTab, setActiveTab] = useState("Message from Buyer");
    const tabs = ["Message from Buyer", "Message From GTP" , "Message From Seller"];

    const renderTabContent = () => {
        switch (activeTab) {
            case "Message from Buyer":
                return <UnapprovedProduce />;
            case "Message From GTP":
                return <ApprovedProduce />;
            case "Message From Seller":
                return <ApprovedProduce />;
            default:
                return <UnapprovedProduce />; // Added return statement
        }
    };

    return (
        <div className="buyer-layout">
            <div className="amtpl-tabs">
                <div className="content3">
                    <main className="main-content">
                        <div className="mb-3 main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${activeTab === tab ? "active" : "notactive"}`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default AmtplCommunication;